import { render } from "./RoomCard.vue?vue&type=template&id=08035dca&scoped=true&ts=true"
import script from "./RoomCard.vue?vue&type=script&lang=ts"
export * from "./RoomCard.vue?vue&type=script&lang=ts"

import "./RoomCard.vue?vue&type=style&index=0&id=08035dca&lang=scss&scoped=true"

import exportComponent from "/opt/booza-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08035dca"]])

export default __exports__